import { BReactComponent } from 'blocks-cloud/b-react-component';
import { BuyModal } from 'reactApp/components/BuyModal/BuyModal';

let buyDialog;
let el;

export const renderBuyModal = ({ id, onSuccess, onClose }: { id: number; onSuccess(); onClose() }): void => {
    const destroyBuyModal = (): void => {
        if (!buyDialog) {
            return;
        }
        buyDialog.destroy();
        buyDialog = null;
    };

    const handleClose = (): void => {
        if (onClose) {
            onClose();
        }
        destroyBuyModal();
    };

    const handleSuccess = (): void => {
        if (onSuccess) {
            onSuccess();
        }
    };

    if (!buyDialog) {
        buyDialog = new BReactComponent({
            ReactComponent: BuyModal,
            renderMode: 'replace',
        });
    } else {
        destroyBuyModal();
    }

    if (!el) {
        el = document.createElement('div');
    }

    document.body.appendChild(el);

    buyDialog.renderTo(el, {
        props: {
            id,
            onSuccess: handleSuccess,
            onClose: handleClose,
        },
    });
};
